import React from "react";

// Renderizador de markdown enxuto e seguro (sem dependências). Cobre o que um
// assistente/copiloto costuma produzir: parágrafos, quebras, listas, títulos,
// **negrito**, *itálico*, `código` e blocos ```de código```. Nada de HTML cru.
// Os estilos das classes md-* ficam no componente que usa (escopados via "& .md-*").

// inline: **bold**, *italic*, `code`, [texto](url)
const renderInline = (text, keyBase) => {
  const nodes = [];
  // regex única alternando os tokens inline
  const re = /(\*\*([^*]+)\*\*)|(\*([^*]+)\*)|(`([^`]+)`)|(\[([^\]]+)\]\((https?:\/\/[^\s)]+)\))/g;
  let last = 0;
  let m;
  let i = 0;
  while ((m = re.exec(text)) !== null) {
    if (m.index > last) nodes.push(text.slice(last, m.index));
    if (m[2] !== undefined) {
      nodes.push(<strong key={`${keyBase}-b${i}`}>{m[2]}</strong>);
    } else if (m[4] !== undefined) {
      nodes.push(<em key={`${keyBase}-i${i}`}>{m[4]}</em>);
    } else if (m[6] !== undefined) {
      nodes.push(
        <code key={`${keyBase}-c${i}`} className="md-code">
          {m[6]}
        </code>
      );
    } else if (m[8] !== undefined) {
      nodes.push(
        <a key={`${keyBase}-a${i}`} href={m[9]} target="_blank" rel="noopener noreferrer">
          {m[8]}
        </a>
      );
    }
    last = re.lastIndex;
    i += 1;
  }
  if (last < text.length) nodes.push(text.slice(last));
  return nodes;
};

const Markdown = ({ text }) => {
  const src = String(text || "");
  const out = [];
  const lines = src.split("\n");
  let i = 0;
  let key = 0;

  while (i < lines.length) {
    const line = lines[i];

    // bloco de código ```
    if (/^```/.test(line.trim())) {
      const buf = [];
      i += 1;
      while (i < lines.length && !/^```/.test(lines[i].trim())) {
        buf.push(lines[i]);
        i += 1;
      }
      i += 1; // pula o fechamento
      out.push(
        <pre key={`pre-${key++}`} className="md-pre">
          <code>{buf.join("\n")}</code>
        </pre>
      );
      continue;
    }

    // título # / ## / ###
    const h = line.match(/^(#{1,3})\s+(.*)$/);
    if (h) {
      const lvl = h[1].length;
      out.push(
        <div key={`h-${key++}`} className={`md-h md-h${lvl}`}>
          {renderInline(h[2], `h${key}`)}
        </div>
      );
      i += 1;
      continue;
    }

    // lista com marcadores
    if (/^\s*[-*]\s+/.test(line)) {
      const items = [];
      while (i < lines.length && /^\s*[-*]\s+/.test(lines[i])) {
        items.push(lines[i].replace(/^\s*[-*]\s+/, ""));
        i += 1;
      }
      const k = key++;
      out.push(
        <ul key={`ul-${k}`} className="md-ul">
          {items.map((it, idx) => (
            <li key={idx}>{renderInline(it, `uli${k}-${idx}`)}</li>
          ))}
        </ul>
      );
      continue;
    }

    // lista numerada
    if (/^\s*\d+\.\s+/.test(line)) {
      const items = [];
      while (i < lines.length && /^\s*\d+\.\s+/.test(lines[i])) {
        items.push(lines[i].replace(/^\s*\d+\.\s+/, ""));
        i += 1;
      }
      const k = key++;
      out.push(
        <ol key={`ol-${k}`} className="md-ol">
          {items.map((it, idx) => (
            <li key={idx}>{renderInline(it, `oli${k}-${idx}`)}</li>
          ))}
        </ol>
      );
      continue;
    }

    // linha em branco → separador entre parágrafos
    if (line.trim() === "") {
      i += 1;
      continue;
    }

    // parágrafo: agrega linhas consecutivas (quebra simples = <br/>)
    const para = [];
    while (
      i < lines.length &&
      lines[i].trim() !== "" &&
      !/^```/.test(lines[i].trim()) &&
      !/^(#{1,3})\s+/.test(lines[i]) &&
      !/^\s*[-*]\s+/.test(lines[i]) &&
      !/^\s*\d+\.\s+/.test(lines[i])
    ) {
      para.push(lines[i]);
      i += 1;
    }
    const k = key++;
    out.push(
      <p key={`p-${k}`} className="md-p">
        {para.map((ln, idx) => (
          <React.Fragment key={idx}>
            {idx > 0 && <br />}
            {renderInline(ln, `p${k}-${idx}`)}
          </React.Fragment>
        ))}
      </p>
    );
  }

  return <div className="md">{out}</div>;
};

export default Markdown;
